import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import withSalonCurrency from 'components/hoc/withSalonCurrency.hoc';
import { withTranslation } from 'providers/GILT.provider';
import asArray from 'utils/arrays/asArray.util';
import elementScrollTo from 'utils/dom/elementScrollTo.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import { addService, changeClient, getFrequentlyBookedList, removeService, saveClientEdit } from 'booking/actions';
import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import BWFooter from 'booking/components/common/BWFooter';
import PageTitle from 'booking/components/common/PageTitle';
import ServiceItem from 'booking/components/common/ServiceItem';

class FrequentlyBooked extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (this.props.client && !this.props.frequentServices.length) {
      this.props.getFrequentlyBookedList(this.props.client.id, this.props.salonId);
    }
  }

  addSpecification = (o, color) => {
    const { addedServices } = this.props;
    const alreadyAdded = addedServices.findIndex((s) => s.service_id === o.id && s.deleted !== true);
    if (alreadyAdded < 0) {
      const newService = Object.assign({}, o);
      if (!newService.appointment) {
        newService.appointment = {};
      }
      newService.service_id = newService.id;
      newService.color = color;
      delete newService.id;
      newService.appointment.client = {
        ...this.props.client,
        notes: '',
        new_client: true,
        labels: [],
        status: 'active',
        clientTags: [],
      };
      newService.selected = true;
      this.props.addService(newService);
    } else {
      const localId = addedServices[alreadyAdded].id;
      this.props.removeService(localId, true);
    }
  };

  goBack = () => {
    this.props.history.goBack();
    setTimeout(() => {
      const div = document.querySelector('.bw-content-wrapper.space');
      if (div) {
        elementScrollTo(div);
      }
    }, 100);
  };

  render() {
    const { t } = this.props;

    return (
      <div data-bem="FrequentlyBooked">
        <div className="BookingWindow">
          <section className="frequently-booked">
            <HeaderWrapper>
              <BackButton
                onClick={() => {
                  this.props.history.goBack();
                }}
              />
              <PageTitle pageTitle={t('scheduler.frequentlyBooked.title')} subTitle="" />
              {/* <CloseButton history={this.props.history} close={closeUrl(this.props.location)} /> */}
              <h3 style={{ fontSize: '16px', lineHeight: '20px' }}>{t('scheduler.frequentlyBooked.subtitle')}</h3>
            </HeaderWrapper>
            <BWContent additionalClass="space">
              {' '}
              <div className="service-list" style={{ paddingTop: 15 }}>
                <div>
                  {this.props.frequentServices && (
                    <div>
                      <section data-bem="FrequentlyBooked__category-list" className="category-list">
                        <div className="category-container pd-bottom">
                          {Array.from(this.props.frequentServices).map((fs, index) =>
                            asArray(fs.services).map((service) => (
                              <div key={createNodeKey({ index, tag: service.id })}>
                                <ServiceItem
                                  service={service}
                                  onClickService={() => void this.addSpecification(service, fs.color)}
                                  addedServices={this.props.addedServices}
                                  backgroundColor={fs.color}
                                />
                              </div>
                            )),
                          )}
                        </div>
                      </section>
                    </div>
                  )}
                </div>
              </div>
            </BWContent>

            <BWFooter additionalClass="apointment-footer border-t sticky-bottom d-flex">
              <button className="btn-booking" onClick={this.goBack}>
                {t('common.buttons.done')}
              </button>
            </BWFooter>
          </section>
        </div>
      </div>
    );
  }
}

const FrequentlyBookedHoc = connect(
  (state) => ({
    client: state.booking.client,
    addedServices: state.booking.addedServices,
    removeService,
    services: state.currentSalon.services,
    frequentServices: state.booking.frequentServices,
    salonId: state.currentSalon.id,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        addService,
        removeService,
        saveClientEdit,
        changeClient,
        getFrequentlyBookedList,
      },
      dispatch,
    ),
)(withTranslation()(withSalonCurrency(FrequentlyBooked)));

export default FrequentlyBookedHoc;
